// src/menu/useStyles.js
import { makeStyles } from "@mui/styles";
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import boldIcon from '../res/sec-logo.svg';
import { Typography } from "@mui/material";

export const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.black, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.15),
    },
    marginRight: theme.spacing(0.25),
    marginLeft: theme.spacing(0.25),
    marginTop: theme.spacing(0.25),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(.25),
        width: 'auto',
    },
}));

export const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
}));

export const BoldIcon = ({ url, width = 75, height = 25 }) => (
    <img
        alt="Smart SGK"
        src={url}
        className="boldIcon"
        style={{ width: 'calc(2rem + 40%)', height: `${height}px` }}

    />
);

export const HeaderText = styled(Typography)(({ theme }) => ({
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
}));



const muiStyles = makeStyles(theme => ({
    boldLabel: {
        flexGrow: 1,
        fontWeight: 'bold',
        whiteSpace: "nowrap",

    },
    boldIcon: {
        marginRight: 20,
    },
    toolBar: {
        paddingLeft: 20,
        paddingRight: 20,
        display: 'flex',
        flexDirection: 'row',  // items aligned horizontally
        alignItems: 'center',  // vertical alignment center
        gap: theme.spacing(3), // optional spacing between items
    },
    appBar: {
        backgroundColor: '#343a40',
        color: 'white',
    },
    sideMenu: {
        width: 300,
        overflowY: 'auto',
        paddingRight: 15,
        boxSizing: 'border-box',
    },
    menu: {
        padding: 0,
        paddingRight: 10
    },
    help: {
        marginTop: 'auto',
        padding: 0,
    },
    logout: {
        padding: 0,
    },
    groupItem: {
        paddingLeft: `calc(0em + ${theme.spacing(.1)})`,
        fontSize: '0.9rem',
        marginLeft: '5px',
        display: 'block',         // Allow the span to behave like a block element
        wordWrap: 'break-word',  // Enable word wrapping
        overflowWrap: 'break-word', // For better compatibility across browsers
        whiteSpace: 'normal',     // Allow white space to wrap
        maxWidth: '200px',
    }
}));

export default muiStyles;
